import React, { useEffect } from 'react';

import {
  Container,
  CTA,
  Text,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { getFeatureAppEnvConfig } from '@vw-marketing/myvw-portal-web-utils/Utils/Helpers/Helper';
import { ThemeProvider } from '@vw-marketing/us-components';

import { EditEmailAddressCTAContainerStyled } from './styled';
import LinkExternal from '../../../../shared/components/icons/LinkExternal';
import {
  onVWBasicInfoMessageLoadEvent,
  onVWBasicButtonClickWithProcessEvent,
} from '../../../../shared/tagging/tagging-helpers';

interface EditEmailAddressViewProps {
  translationHandler: (key: string) => string;
  trackingManager: any;
  logout: () => void;
  onClose: () => void;
}

export const EditEmailAddressView = ({
  translationHandler,
  trackingManager,
  logout,
  onClose,
}: EditEmailAddressViewProps) => {
  useEffect(() => {
    try {
      onVWBasicInfoMessageLoadEvent(trackingManager, {
        Name: 'Account Settings',
        StepName: 'Personal Information and Security',
        StepNumber: '4',
      });
    } catch (error) {
      console.warn('Error tracking email modal load:', error);
    }
  }, [trackingManager]);

  const handleContinueAction = () => {
    try {
      onVWBasicButtonClickWithProcessEvent(trackingManager, {
        Name: 'Account Settings',
        StepName: 'Personal Information and Security',
        StepNumber: '4',
      }, { name: 'Continue' });
    } catch (error) {
      console.warn('Error tracking continue button click:', error);
    }
    window.open(getFeatureAppEnvConfig().MYVW_RESET_INFORMATION_URL);
    onClose();
    logout();
  };

  const handleCancelAction = () => {
    try {
      onVWBasicButtonClickWithProcessEvent(trackingManager, {
        Name: 'Account Settings',
        StepName: 'Personal Information and Security',
        StepNumber: '4',
      }, {
        name: 'Cancel',
      });
    } catch (error) {
      console.warn('Error tracking cancel button click:', error);
    }
    onClose();
  };

  return (
    <ThemeProvider theme="main">
      <Container
        gutter="static350"
        padding="grid001"
        wrap="always"
      >
        <Text bold appearance={TokenTextAppearance.headline300}>
          {translationHandler('accountSettings.edit.email.modal.title')}
        </Text>
        <Text>
          {translationHandler('accountSettings.edit.email.modal.description')}
        </Text>
        <EditEmailAddressCTAContainerStyled>
          <CTA
            onClick={handleContinueAction}
            tag="button"
            emphasis="primary"
            icon={<LinkExternal />}
            iconPosition='end'
          >
            {translationHandler('accountSettings.edit.email.modal.action.continue')}
          </CTA>
          <CTA
            onClick={handleCancelAction}
            tag="button"
            emphasis="secondary"
          >
            {translationHandler('accountSettings.edit.email.modal.action.cancel')}
          </CTA>
        </EditEmailAddressCTAContainerStyled>
      </Container>
    </ThemeProvider>
  );
};
